/* eslint-disable max-params */
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { NoveltyCheckReportState } from '../novelty-check-report-state';
import { NoveltyCheckTaskStep } from '@/domains/novelty-check-report/enums';
import { Logger, Message } from '@patsnap/tahiti-core';
import { NoveltyCheckTaskStatusModel } from '@/domains/novelty-check-report/models/novelty-check-task-status-model';
import { SummaryTechFeaturesService } from '../../summary-tech-features-service';
import { CurrentTaskService } from '@/services/current-task/current-task-service';
import { I18nService } from '@telecom/shared/services/i18n';
import type { NoveltyCheckReportContext } from '../novelty-check-report-context';
import { NoveltyCheckTaskStatusService } from '../../task-status-service';

@injectable()
export class SummaryState implements NoveltyCheckReportState {
    constructor(
        @inject(Logger)
        private readonly _logger: Logger,
        @inject(NoveltyCheckTaskStatusModel)
        private readonly _noveltyCheckTaskStatusModel: NoveltyCheckTaskStatusModel,
        @inject(CurrentTaskService)
        private readonly _currentTaskService: CurrentTaskService,
        @inject(SummaryTechFeaturesService)
        private readonly _summaryTechFeaturesService: SummaryTechFeaturesService,
        @inject(Message)
        private readonly _message: Message,
        @inject(I18nService)
        private readonly _i18nService: I18nService,
        @inject(NoveltyCheckTaskStatusService)
        private readonly _noveltyCheckTaskStatusService: NoveltyCheckTaskStatusService,
    ) { }

    async enter(context: NoveltyCheckReportContext): Promise<void> {
        this._logger.info('进入<总结用户输入为技术要点>状态');
        this._switchTaskStep(NoveltyCheckTaskStep.SUMMARY);

        const taskId = this._currentTaskService.taskId;
        try {
            const text = await this._summaryTechFeaturesService.pullSummary(taskId);
            this._handleSummaryTechFeaturesEmpty(text);
            this._logger.info('技术要点总结完成');
        } catch (error) {
            const message = this._i18nService.t('novelty.errors.summaryTechFeaturesEmpty');
            this._message.warning({ message });
            this._logger.error('技术要点总结失败', error);
        }
    }

    private _handleSummaryTechFeaturesEmpty(text: string) {
        if (!text) {
            throw new Error('总结技术要点失败');
        }
    }

    async handleNext(context: NoveltyCheckReportContext): Promise<void> {
        const state = context.getState(NoveltyCheckTaskStep.NOVELTY_SEARCH_TECH_FEATURE);
        await context.transitionTo(state);
    }

    /**
     * 切换任务步骤
     * @param step 目标步骤
     */
    private _switchTaskStep(step: NoveltyCheckTaskStep) {
        this._noveltyCheckTaskStatusModel.update(state => {
            state.taskStep = step;
            return state;
        });
    }

    handlePrevious(): Promise<void> {
        this._logger.warn('<总结用户输入为技术要点>状态没有前一个状态');
        return Promise.resolve();
    }
}
